module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-btn-form', {
    attrs: {
      "title": _vm.title
    },
    on: {
      "close": function($event) {
        return _vm.cancel()
      }
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function() {
        return [_c('v-btn', {
          attrs: {
            "disabled": !_vm.valid
          },
          on: {
            "click": _vm.add
          }
        }, [_vm._v("Направить")]), _vm._v(" "), _c('v-spacer')]
      },
      proxy: true
    }])
  }, [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-card-text', [_c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-flex', [_c('v-textarea', {
    ref: "focused",
    attrs: {
      "label": "Текст",
      "rows": "5",
      "hint": "",
      "rules": [function (v) { return !!v || 'введите текст'; }]
    },
    model: {
      value: (_vm.item.text),
      callback: function($$v) {
        _vm.$set(_vm.item, "text", $$v)
      },
      expression: "item.text"
    }
  })], 1), _vm._v(" "), _c('v-flex', [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "prepend-icon": "attach_file",
      "label": "Ссылка на документ",
      "hint": ""
    },
    on: {
      "click:prepend": _vm.dialogOpen
    },
    model: {
      value: (_vm.item.link),
      callback: function($$v) {
        _vm.$set(_vm.item, "link", $$v)
      },
      expression: "item.link"
    }
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "disabled": !this.item.link
    },
    on: {
      "click": _vm.addLink
    }
  }, [_vm._v("Добавить")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-699fcb9a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat/PostForm.vue
// module id = 1199
// module chunks = 1